export default __webpack_public_path__ + "static/media/dozule17.9afdc9c5.jpg";